import React from 'react';
import { useNavigate } from 'react-router-dom';
import {config} from '../config'; 
import './footer.css';

const Footer = () => {
    const navigate = useNavigate();



  return (
    <>
     <div className='footerMenu'>
     <div className='footerMenuContent'>
     <button onClick={() => {navigate('/');}} ><img src={config.homeFooter} alt="Home"  className='footerMenuIcon' />Home</button>
     <button onClick={() => {navigate('/history');}}><img src={config.historyFooter} alt="History" className='footerMenuIcon' />History</button>
     <button onClick={() => {navigate('/templates');}}><img src={config.templatesFooter} alt="Templates" className='footerMenuIcon' />Templates</button>
     </div>
     </div>
    </>
  );
}

export default Footer;
